import { message } from "antd";
import { concat, from, of } from "rxjs";
import { catchError, filter, switchMap } from "rxjs/operators";
import { startLoading, stopLoading } from "../loading";
import type { RootEpic } from "../types";
import { uploadFileActions } from "../uploadFiles/uploadFileSlice";
import archiveFileService from "./archiveFileService";
import { archiveFileActions } from "./archiveFileSlice";

export const archiveFileEpic$: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(archiveFileActions.archiveFileRequest.match),
    switchMap((action) => {
      const { bucketName, sourceKey, reason, version } = action.payload;

      return concat(
        [startLoading({ key: "archiveFile" })],
        archiveFileService.archiveFile({ bucketName, sourceKey, reason, version }).pipe(
          switchMap(() => {
            message.success("File archived successfully");

            return from([
              archiveFileActions.archiveFileSuccess(),
              // Trigger reload data
              uploadFileActions.setLastUploadAt(Date.now())
            ]);
          }),
          catchError((err) => {
            message.error(err.message || "Error archiving file");
            return of(
              archiveFileActions.archiveFileFailure(err.message || "Error archiving file")
            );
          })
        ),
        [stopLoading({ key: "archiveFile" })]
      );
    })
  );

export const archiveFileEpics = [archiveFileEpic$];
